import { status } from 'constants/general';
import { initialDiscountsState } from 'store/initialStates';
import discountsActionTypes from './action-types';

const discountsReducer = (state = initialDiscountsState, { type, payload }) => {
  switch (type) {
    case discountsActionTypes.FETCH_DISCOUNTS_LIST:
      return {
        ...state,
        discountsListLoadStatus: status.FETCHING,
      };
    case discountsActionTypes.FETCH_DISCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        discountsList: payload,
        discountsListLoadStatus: status.SUCCESS,
      };
    case discountsActionTypes.FETCH_DISCOUNTS_LIST_FAIL:
      return {
        ...state,
        discountsListLoadStatus: status.FAIL,
      };

    case discountsActionTypes.SEARCH_PRODUCTS:
      return {
        ...state,
        productSearchResultsLoadStatus: status.FETCHING,
      };
    case discountsActionTypes.SEARCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        productSearchResults: payload,
        productSearchResultsLoadStatus: status.SUCCESS,
      };
    case discountsActionTypes.SEARCH_PRODUCTS_FAIL:
      return {
        ...state,
        productSearchResultsLoadStatus: status.FAIL,
      };

    case discountsActionTypes.CREATE_DISCOUNT:
      return {
        ...state,
        isCreatingDiscount: true,
        createDiscountSuccess: false,
        createDiscountError: null,
      };
    case discountsActionTypes.CREATE_DISCOUNT_SUCCESS:
      return {
        ...state,
        isCreatingDiscount: false,
        createDiscountSuccess: true,
      };
    case discountsActionTypes.CREATE_DISCOUNT_FAIL:
      return {
        ...state,
        isCreatingDiscount: false,
        createDiscountSuccess: false,
        createDiscountError: payload,
      };

    case discountsActionTypes.UPDATE_DISCOUNT:
      return {
        ...state,
        isUpdatingDiscount: true,
        updateDiscountSuccess: false,
      };
    case discountsActionTypes.UPDATE_DISCOUNT_SUCCESS:
      return {
        ...state,
        isUpdatingDiscount: false,
        updateDiscountSuccess: true,
      };
    case discountsActionTypes.UPDATE_DISCOUNT_FAIL:
      return {
        ...state,
        isUpdatingDiscount: false,
        updateDiscountSuccess: false,
      };

    case discountsActionTypes.FETCH_OFFERS_PRODUCTS:
      return {
        ...state,
        offersProductsLoadStatus: status.FETCHING,
      };
    case discountsActionTypes.FETCH_OFFERS_PRODUCTS_SUCCESS:
      return {
        ...state,
        offersProducts: payload,
        offersProductsLoadStatus: status.SUCCESS,
      };
    case discountsActionTypes.FETCH_OFFERS_PRODUCTS_FAIL:
      return {
        ...state,
        offersProductsLoadStatus: status.FAIL,
      };

    case discountsActionTypes.PERFORM_OFFER_ACTION:
      return {
        ...state,
        isPerformingAction: true,
        performActionSuccess: false,
        performActionError: null,
      };
    case discountsActionTypes.PERFORM_OFFER_ACTION_SUCCESS:
      return {
        ...state,
        isPerformingAction: false,
        performActionSuccess: true,
      };
    case discountsActionTypes.PERFORM_OFFER_ACTION_FAIL:
      return {
        ...state,
        isPerformingAction: false,
        performActionSuccess: false,
        performActionError: payload,
      };

    default:
      return state;
  }
};

export default discountsReducer;
